import Form from 'JS/form/Form';
import { notice } from 'JS/utils/notice';

class ResetPasswordForm {

    /**
     * @type {Form}
     */
    form;

    /**
     * @type {HTMLFormElement}
     */
    formElement;

    /**
     * @type {HTMLElement}
     */
    submitButton;

    isLoading = false;

    /**
     * 
     * @param {HTMLFormElement} formElement 
     */
    constructor(formElement) {
        if (!formElement) {
            return;
        }

        this.formElement = formElement;
        this.form = new Form(this.formElement);
        this.submitButton = this.formElement.querySelector('.pass-lost__form-submit');

        this.addListeners();
    }

    addListeners() {
        this.form.on('submit', (data) => {
            this.request(data);
        });
    }

    request(data) {
        if (this.isLoading) {
            return;
        }

        const formData = new FormData();

        formData.append('action', 'user_reset_password');
        formData.append('data', JSON.stringify(data));

        this.isLoading = true;
        this.submitButton.classList.add('processing');

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                const {
                    data,
                    success
                } = response;

                if (!success) {
                    this.onError(data.message);
                    return;
                }

                if (data.message) {
                    notice(data.message);
                }
            })
            .catch((error) => {
                this.onError(error);
            })
            .finally(() => {
                this.isLoading = false;
                this.submitButton.classList.remove('processing');
            });
    }

    onError(error) {
        const errorText = error || 'Что-то пошло не так, попробуйте перезагрузить страницу';
        notice(errorText, 'error');
    }
};

const initResetForm = () => {
    const form = document.querySelector('.pass-lost__form--email');

    if (!form) {
        return;
    }

    new ResetPasswordForm(form);
};

(() => {
    initResetForm();
})();
